export default __webpack_public_path__ + "static/media/map-poi-icon.c1a56f8c.svg";